import get from 'lodash/get'
import { ANALYTICS_EVENTS } from '../utils'

export const getShipmentTrackingHandler = ({ events }) => {
  const {
    SHIPMENT_VIEWED,
    SHIPMENT_DELIVERY_STARTED,
    SHIPMENT_DISCREPANCY_FLAGGED,
    SHIPMENT_DELIVERY_CONFIRMED
  } = ANALYTICS_EVENTS

  return {
    viewed: (data) => {
      const shipment = get(data, 'shipment')
      events.track(SHIPMENT_VIEWED, {
        shipment_id: shipment.id,
        status: shipment.status
      })
    },

    started: (data) => {
      const shipment = get(data, 'shipment')
      events.track(SHIPMENT_DELIVERY_STARTED, {
        shipment_id: shipment.id
      })
    },

    flagged: (data) => {
      const shipmentId = get(data, 'shipmentId')
      const fieldFlagged = get(data, 'fieldFlagged')
      events.track(SHIPMENT_DISCREPANCY_FLAGGED, {
        shipment_id: shipmentId,
        field_flagged: fieldFlagged
      })
    },

    confirmed: (data) => {
      const shipmentId = get(data, 'shipmentId')
      const confirmedBy = get(data, 'confirmedBy')

      const newData = {
        shipment_id: shipmentId,
        confirmed_by: confirmedBy
      }

      if (data.discrepancyFlag) {
        newData.discrepancy_flag = data.discrepancyFlag
      }

      events.track(SHIPMENT_DELIVERY_CONFIRMED, newData)
    }
  }
}
